// src/components/Posts/PostContent.jsx
import { Box, Typography } from '@mui/material';

const PostContent = ({ post }) => (
  <>
    {/* 본문 + 회색 배경 박스 */}
    <Box
      sx={{
        my: 3,
        p: { xs: 1.5, sm: 3 },
        backgroundColor: 'grey.50',
        borderRadius: 1,
      }}
    >
      <Box
        className="tiptap"
        sx={{
          whiteSpace: 'pre-wrap',
          textAlign: 'left',
          fontSize: { xs: '0.75rem', sm: '0.75rem', md: '1rem' },
          lineHeight: 1.6,
          '& a': {
            color: '#1976d2',          // 파란색 
            textDecoration: 'underline', // 밑줄 
            wordBreak: 'break-all',    // 긴 주소도 줄바꿈 
            cursor: 'pointer',
          },
          '& ul, & ol': {
            listStylePosition: 'outside',
            paddingLeft: '1.15rem',
            margin: 0,
          },
          '& ul ul, & ol ul, & ul ol, & ol ol': {
            paddingLeft: '0.7rem',
            margin: 0,
          },
          '& ul ul ul, & ol ul ul, & ul ol ul, & ol ol ul': {
            paddingLeft: '0.6rem',
            margin: 0,
          },
          '& li': { margin: '0.25rem 0' },
          '& img, & video': {
            display: 'block',
            maxWidth: '100%',
            width: 'auto',
            height: 'auto !important',
            objectFit: 'contain',
            borderRadius: 2,
            margin: '1rem 0',
          },
          '& p': { margin: '0.5rem 0' },
          '& p:empty': { minHeight: '1em' },

        }}
        dangerouslySetInnerHTML={{ __html: post.content }}
      />
    </Box>

    {/* 첨부파일 다운로드 영역 */}
    {post.attachment && (
      <Box sx={{ mt: 2, textAlign: 'left', px: 1 }}>
        <Typography variant="body2" fontWeight="bold">
          📎 첨부파일:&nbsp;
          <a
            href={`/api/posts/${post.id}/download/`}
            style={{ textDecoration: 'underline', color: '#1976d2' }}
          >
            다운로드
          </a>
        </Typography>
      </Box>
    )}
  </>
);

export default PostContent;